import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { ProductDetails, isBoolean, isFailedProductsResponse, isNull } from '@models';
import { SkeletonTemplateService } from '@skeleton-loader';

import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { ProductCardsComponent } from '../product-cards/product-cards.component';
import { SectionDataFailureErrorComponent } from '../section-data-failure-error/section-data-failure-error.component';

@Component({
  selector: 'lib-product-card-slider',
  templateUrl: './product-card-slider.component.html',
  styleUrl: './product-card-slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButton, ProductCardsComponent, SectionDataFailureErrorComponent],
})
export class ProductCardSliderComponent {
  products = input.required<ProductDetails[]>();
  isLoading = input<boolean | null>(null);
  title = input<string>();
  subTitle = input<string>();
  withAction = input<boolean>(true);
  actionText = input<string>('See All');
  ariaLabelAction = input(this.actionText());
  withControls = input<boolean>(true);

  action = output<void>();

  isLoadingFlagPassed = computed(() => !isNull(this.isLoading()));
  showLoader = computed(() => isBoolean(this.isLoading()) && this.isLoading());

  isFetchResponseFailed = computed(() => isFailedProductsResponse(this.products()));

  readonly skeletonService = inject(SkeletonTemplateService);

  onAction(): void {
    this.action.emit();
  }
}
